document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('cart-items')) return;

  var cartItems = document.querySelector('cart-items');
  var cartFooter = document.querySelector('.cart__footer');
  if (!cartItems || !cartFooter) return;

  // ── Gesamtpreis korrekt auslesen (aus dem Footer, nicht aus Items) ──
  var totalText = '';
  // Methode 1: .totals__total-value
  var totalEl = cartFooter.querySelector('.totals__total-value');
  if (totalEl) {
    totalText = totalEl.textContent.trim().replace(/\s*EUR/g, '');
  }
  // Methode 2: Falls nicht gefunden, alle Preise summieren
  if (!totalText) {
    var prices = document.querySelectorAll('.price--end .price-item--regular, .cart-item__totals .price');
    var sum = 0;
    prices.forEach(function(p) {
      var val = p.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
      sum += parseFloat(val) || 0;
    });
    if (sum > 0) {
      totalText = '€' + sum.toFixed(2).replace('.', ',');
    }
  }

  // ── Grid bauen ──
  var grid = document.createElement('div');
  grid.id = 'custom-cart-grid';

  var left = document.createElement('div');
  left.id = 'custom-cart-left';

  var right = document.createElement('div');
  right.id = 'custom-cart-right';

  // Payment SVGs
  var paymentSVGs =
    '<svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"/></svg>' +
    '<svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><circle fill="#EB001B" cx="15" cy="12" r="7"/><circle fill="#F79E1B" cx="23" cy="12" r="7"/><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"/></svg>' +
    '<svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"/><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"/><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"/></svg>' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24"><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000"/><path d="M35.889 0C37.05 0 38 .982 38 2.182v19.636c0 1.2-.95 2.182-2.111 2.182H2.11C.95 24 0 23.018 0 21.818V2.182C0 .982.95 0 2.111 0H35.89z" fill="#5A31F4"/><path d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003z" fill="#fff"/></svg>';
const lang = document.documentElement.lang.toLowerCase().startsWith('en') ? 'en' : 'de';

const t = {
  total: lang === 'en' ? 'Total' : 'Gesamtkosten',
  notice: lang === 'en'
    ? 'Taxes included. Shipping calculated at checkout.'
    : 'Inkl. Steuern. Versand wird beim Checkout berechnet.',
  checkout: lang === 'en' ? 'Checkout' : 'Zur Kasse',
  secure: lang === 'en'
    ? '100% Secure Payment'
    : '100% Sichere Zahlung'
};
  right.innerHTML =
    '<div class="cart-summary-card">' +
      '<div class="cart-summary-total">' +
        '<span>' + t.total + '</span>' +
        '<span class="cart-summary-total-value" style="margin-left:0.5rem">' + totalText + '</span>' +
      '</div>' +
      '<div class="cart-summary-notice">' + t.notice + '</div>' +
      '<form action="/cart" method="post" id="custom-checkout-form">' +
        '<button type="submit" name="checkout" class="cart-summary-checkout">' + t.checkout + '</button>' +
      '</form>' +
      '<div class="secure-payments">' +
        '<div class="secure-payments-title">' +
          '<svg width="14" height="16" viewBox="0 0 12 15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">' +
            '<path d="M6 1C4.32 1 3 2.375 3 4.125V6h6V4.125C9 2.375 7.68 1 6 1zM1 6h10v8H1z"/>' +
          '</svg>' +
          t.secure +
        '</div>' +
        '<div class="payment-icons">' + paymentSVGs + '</div>' +
      '</div>' +
    '</div>';

  // ── Elemente umbauen ──
  var parent = cartItems.parentElement;
  parent.insertBefore(grid, cartItems);
  left.appendChild(cartItems);
  grid.appendChild(left);
  grid.appendChild(right);

  // Original Footer verstecken
  cartFooter.style.display = 'none';

  // ── Preis-Update Observer ──
  var updating = false;
  var observer = new MutationObserver(function() {
    if (updating) return;
    var src = document.querySelector('.cart__footer .totals__total-value, .cart__footer .price--end');
    var dest = document.querySelector('.cart-summary-total-value');
    if (src && dest) {
      var newText = src.textContent.trim().replace(/\s*EUR/g, '');
      if (dest.textContent !== newText) {
        updating = true;
        dest.textContent = newText;
        setTimeout(function() { updating = false; }, 100);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
});